import React, { useEffect, useState } from 'react';
import { View } from 'react-native';
import _ from 'lodash';
import { FlexElement, MetricStackTitle, ShinyBlockOuter, ShinyBody, ShinyHeading, BasicText as Text } from '../../Styles';
import { Calendar } from '../../core/Calendar';

const PickupDetail = ({scope = {event: {}}}) => {
    if(scope == undefined || scope.event.label == undefined){
        return null;
    }

	return <View key={scope.event.label} style={{ backgroundColor: scope.event.color, padding: 2, flexDirection: "row", justifyContent: "space-between"}}>
        <Text style={{color: "white"}}>
            {scope.event.label}
        </Text>
    </View>;
}

const Schedule = ({site, services, setPosition = undefined}) => {
    const [schedule, setSchedule] = useState([]);

    useEffect(()=>{
        const filteredServices = _.filter(services, (s)=>s.schedule != undefined);

        if(filteredServices != undefined && filteredServices.length > 0){
            setSchedule(_.flatMap(filteredServices, "schedule"));
        }
    }, [services]);

    const doStuff = (event) => {
        setPosition(event.nativeEvent.layout)
    }

    return <ShinyBlockOuter onLayout={event => doStuff(event)} flexBasis={"95%"}>
        <ShinyHeading>
            <MetricStackTitle>Schedule</MetricStackTitle>
        </ShinyHeading>
        <ShinyBody>
            <Calendar data={schedule} dateVarName={"date"} onClickDay={(day, date)=>console.log("do something here probably with ", day, date)}>
                <PickupDetail />
            </Calendar>
        </ShinyBody>
    </ShinyBlockOuter>;
}

export default Schedule;